/**
 * Lib.Common: Graphing and charting component declarations
 */


import ibGaugeSolid         from './ib-gauge-solid.vue';


export default [
    ibGaugeSolid
];
